import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { LanePosition, LanePositionLabel } from '@core/models/brijjsports.enums';
import { Athlete } from '@core/models/brijjsports.models';

@Component({
  selector: 'app-coach-scoring-setup-archer-pick-row',
  standalone: true,
  imports: [MatCheckboxModule, MatFormFieldModule, MatInputModule, MatSelectModule],
  templateUrl: './archer-pick-row.component.html',
  styleUrl: './archer-pick-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArcherPickRowComponent {
  readonly athlete = input.required<Athlete>();
  readonly picked = input.required<boolean>();
  readonly showLane = input.required<boolean>();
  readonly laneNumber = input.required<number>();
  readonly position = input.required<LanePosition>();
  readonly selectionToggle = output<void>();
  readonly laneChange = output<number>();
  readonly positionChange = output<LanePosition>();

  protected readonly positions = [LanePosition.A, LanePosition.B, LanePosition.C];
  protected readonly positionLabel = LanePositionLabel;

  onLaneInput(ev: Event): void {
    const value = Number((ev.target as HTMLInputElement).value);
    if (Number.isFinite(value) && value > 0) this.laneChange.emit(value);
  }
}
